<template>
	<div class="Finances">
		<vs-prompt
			@cancel="date = ''"
			@accept="removePayout"
			:active.sync="activePrompt2"
			:title="$t('rejectPayment')"
			:acceptText="$t('decline')"
			:cancelText="$t('cancel')"
      :is-valid="!(about.length < 3 || about.length > 190)"
			color="danger"
		>
			<div class="flex items-end">
				<div class="vx-col w-full">
					<div class="vs-component vs-con-input-label vs-input vs-input-primary w-full">
						<label class="vs-input--label">{{ $t('paymentRejectingReason') }}</label>
						<div class="vs-con-input">
						</div>
						<vs-textarea class="w-full" v-model="about" name="about" v-validate="'required|min:3|max:190'"/>
					</div>

					<div
            v-if="errors.first('about')"
            class="text-danger text-sm"
          >
            <span v-if="about.length < 3">
              {{ $t('minLength', { n: 3 }) }}
            </span>

            <span v-if="about.length > 190">
              {{ $t('maxLength', { n: 190 }) }}
            </span>
        </div>
				</div>
			</div>
		</vs-prompt>
		<div class="vx-row items-center" v-if="$store.state.auth.role !== 'accountant'">
			<div class="vx-col lg:w-1/4 w-full mb-10">
				<vx-card>
					<div class="flex justify-between items-center box-top">
						<div class="des w-full">
							<b>{{ incomes }} Є</b>
							<p>{{ $t('currentBalance') }} </p>
						</div>
						<div class="icon ml-3">
							<feather-icon icon="CreditCardIcon"></feather-icon>
						</div>
					</div>
				</vx-card>
			</div>
			<div class="vx-col lg:w-3/4 w-full mb-10">
				<div class="buttons flex justify-end ">
					<vs-button color="success" @click="activePrompt = true">{{ $t('withdraw') }}</vs-button>
				</div>
			</div>
		</div>

		<vx-card class="my-8">
			<vs-tabs v-if="tabs.length > 0" @setActiveTab="setActiveTab">
				<vs-tab
					v-for="tab in tabs"
					:key="tab.title"
					:value="indexTab"
					:label="
						$store.state.auth.role !== 'author'
							? tab.title
							: tab.title + ' (' + orders[tab.key].length + ')'
					"
				>
					<div class="filter p-0 pb-1">
						<v-select
							v-model="user"
							style="min-width: 170px;margin-right: 20px"
							v-if="$store.state.auth.role === 'accountant'"
							:options="users"
							:reduce="item => item.id"
							label="name"
							class="single-row-select py-2"
						/>
						<div class="date vx-row">
							<vx-input-group class="vx-col py-2">
								<div
									class="vs-component vs-con-input-label vs-input vs-input-primary"
								>
									<div class="vs-con-input"></div>
									<vs-datepicker
										v-model="off"
										:placeholder="$t('from')"
										:disabled="isLoading"
										format="dd.MM.yyyy"
										name="date"
									></vs-datepicker>
								</div>
							</vx-input-group>
							<vx-input-group class="vx-col py-2">
								<div
									class="vs-component vs-con-input-label vs-input vs-input-primary"
								>
									<div class="vs-con-input"></div>
									<vs-datepicker
										v-model="to"
										:placeholder="$t('to')"
										:disabled="isLoading"
										format="dd.MM.yyyy"
										name="date"
									></vs-datepicker>
								</div>
							</vx-input-group>
							<div class="vx-col py-2">
								<vs-custom-button
									color="dark"
									type="border"
									@click="(off = ''), (to = '')"
								>{{ $t('reset') }}
								</vs-custom-button>
							</div>
              <div v-if="$store.state.auth.role === 'accountant'" class="vx-col download-btn py-2">
				  <vs-custom-button
					  @click="downloadExcelFile(tabs[indexTab].key, tabs[indexTab].filterOptions || '')"
					  color="dark"
					  type="border"
					  class="vs-custom-button vs-button-text"
				  >
					  {{ $t("download") }}
					  <feather-icon svgClasses="h-5 w-5" class="feather-icon" icon="DownloadIcon" />
				  </vs-custom-button>

			  </div>
						</div>
					</div>
          <div class="perPage">
						<v-select
              class="single-row-select"
              v-model="select1"
							label=""
              :searchable="false"
              :options="[20,50,100]"
            />
					</div>
					<div class="tab-text">
						<vs-table
              class=""
              :max-items="select1"
              pagination
              :data="orders[tab.key]"
							:currentPage="currentPage"
							@change-page="setPageNumber"
            >
							<template slot="thead" v-if="$store.state.auth.role === 'author'">
								<vs-th v-for="fil in field"
									   :style="'width:' +fil.width"
									   :class="{'justify-center': fil.align && fil.align === 'center','text-center': fil.align && fil.align === 'center'}">
									   <p v-if="showTitle(tab.key, fil.field)">{{ fil.title }}</p>
								</vs-th>
							</template>
							<template slot="thead" v-else>
								<vs-th v-for="fil in field" v-if="tab.key === 'request' || fil.field !== 'actions'"
									   :style="'width:' +fil.width"
									   :class="{'justify-center': fil.align && fil.align === 'center','text-center': fil.align && fil.align === 'center'}">
									{{ fil.title }}
								</vs-th>
							</template>

							<template slot-scope="{ data }">
								<vs-tr :key="tr.id" v-for="(tr, indextr) in data">
									<template v-for="fil in field">
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-if="fil.field === 'name'">
											<router-link :to="'ticket/' + tr.id">
												{{ tr.name }}
											</router-link>
										</vs-td>

										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'user'">
											<!--											<router-link :to="'client/' + deepFind(tr, 'client.id')">-->
											<div v-if="$store.state.auth.role === 'accountant'">
												{{ tr.user ? tr.user.username : '' }}
											</div>

											<router-link v-else :to="getLinkToUser(tr)">
												{{ tr.user ? tr.user.username : '' }}
											</router-link>
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'transaction_uid'">
											<p>
												{{ tr.transaction_uid }}
											</p>
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'payment_system'">
											<p>
												{{ getTypeName(tr.payment_system) }}
											</p>
										</vs-td>

										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'penalty_reason'">
												{{ tr.penalty_reason }}
										</vs-td>

										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'author.username'">
											<router-link v-if="tr[fil.field]"
														 :to="'client/' + deepFind(tr, 'author.id')">
												{{ deepFind(tr, fil.field) }}
											</router-link>
										</vs-td>

										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'status'">
											<template>
												<span
													v-if="tr.status === 5"
													class="transfer-status transfer-status_warn"
												>{{ $t('pendingConsideration') }}</span>

												<span
													v-if="tr.status === 10"
													class="transfer-status transfer-status_success"
												>{{ $t('paidOut') }}</span>

												<span v-if="tr.status === 0" class="flex items-center justify-center">
													<span
														class="transfer-status transfer-status_failed"
													>{{ $t('rejected') }}</span>
													<vs-dropdown
														v-if="tr.status_message"
														vs-custom-content
														vs-collapse
														vs-trigger-click
														:fixed="true"
														class="circle cursor-pointer flex items-center ml-3"
														icon="MoreHorizontalIcon"
													>
														<feather-icon
															icon="AlertTriangleIcon"
															class="flex items-center transfer-status_failed"
														/>

														<vs-dropdown-menu
															:fixed="true"
															class="w-48 break-words hyphens-auto finances-status-dropdown"
														>
															<div class="p-2">
																{{ tr.status_message }}
															</div>
														</vs-dropdown-menu>
													</vs-dropdown>
													<!-- <div v-else style="width: 24px; height: 24px;"></div> -->
												</span>
											</template>
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'milestone_position'">
											{{ tr.milestone_position }}
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'milestone_id'">
											{{ tr.milestone_id }}
										</vs-td>
										<template v-else-if="fil.field === 'actions'">
											<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
												   v-if="tab.key === 'request' ">
												<div class="flex">
													<vs-button
														@click="showCancelDialog(tr)"
														size="small"
														color="danger" class="mr-3"
														:disabled="checkDisableRowPairs(tr.id)"
													>
														{{ $t('decline') }}
													</vs-button>
													<vs-button
														@click.once="payout(tr.id, tab, indextr)"
														size="small"
														color="success"
														:disabled="checkDisableRowPairs(tr.id)"
												>
														{{ $t('pay') }}
													</vs-button>
												</div>
											</vs-td>
										</template>


										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'chat_messages_count'">
											<span
												class="counter"
												:class="{ warn: tr.is_chat_unread }"
											>
												{{ tr.chat_messages_count }}
											</span>
										</vs-td>

										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'subject'">
											{{
												$getDeep(tr.subject, subjects)
											}}
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'work_type'">
											{{
												$getDeep(tr.work_type, works)
											}}
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'order_id'">

											   <div class="d-flex flex-wrap justify-center" v-if="typeof tr.order_id === 'number'">
												   <router-link
														class="mr-2"
														:to="'/ticket/' + tr.order_id"
													>
													   {{ tr.order_id }}
												   </router-link>
											   </div>
											   <div class="d-flex flex-wrap justify-center" v-else>
												   <router-link
												   		v-for="(ticket, index) in tr[fil.field]"
													    :key="ticket"
														class="mr-2"
														:to="'/ticket/' + ticket.split(',').join('')"
													>
													   {{ ticket }} {{ addComa(tr[fil.field], index) }}
												   </router-link>
											   </div>
											<!-- {{
												tr[fil.field].join(', ')
											}} -->
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'quality_level'">
											{{
												$getDeep(tr.quality_level, levels)
											}}
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'task'">
											<span class="task"
												  v-if="tr[fil.field]">{{ tr[fil.field].date_time | moment('DD.MM.YYYY') }}</span>
											<span class="task" @click="idOrder = tr.id;activePrompt = true"
												  v-else>+</span>
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'amount'">
											{{ tr[fil.field] || $t('warning') }}
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'operation'">
                         <p v-if="tab.key === 'manualCredits'">
											    {{  $t(`operation.${tr[fil.field]}`) }}
                         </p>
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="tr[fil.field]">
											{{ tr[fil.field] }}
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else>
											...
										</vs-td>
									</template>

								</vs-tr>
							</template>
						</vs-table>
					</div>
				</vs-tab>
			</vs-tabs>
		</vx-card>
		<vs-prompt
			@cancel="date = ''"
			@accept="createTask"
			:active.sync="activePrompt"
			:title="$t('payRequest')"
			color="success"
			:acceptText="$t('save')"
			:cancelText="$t('cancel')"
			class="withdraw"
		>

			<div v-if="$store.state.auth.role === 'author'" class="con-exemple-prompt">


				<vs-input
					v-model="amount"
					name="amount"
					:label="$t('writeHowMuchYouWantToWithdraw')"
					v-validate="'required|min:1'"
					color="success"
				/>
				<v-select
					v-model="selectedFinances"
					:options="completedTickets"
					:placeholder="$t('finances')"
          			:close-on-select="false"
					clearable
					multiple
					class="w-full mt-4 mr-8"
					label="id"
				>
					<template #footer>
						<div class="d-flex justify-between w-full v-select-footer">
							<vs-button
								size="small"
								type="line"
								color="primary"
								@click="selectAllFinances"

								class="pl-3 pr-3"
							>{{$t('all')}}</vs-button>
							<vs-button
								size="small"
								type="line"
								color="primary"
								@click="cleanSelectedFinances"

								class="pl-3 pr-3"
							>{{$t('clean')}}</vs-button>
						</div>
					</template>
				</v-select>
				<span v-if="errors.first('amount')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
			<div v-else class="con-exemple-prompt">
				<vs-input
					v-model="amount"
					name="amount"
					:label="$t('writeHowMuchYouWantToWithdraw')"
					v-validate="'required|min:1'"
					color="success"
				/>
				<span v-if="errors.first('amount')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>

			<div class="payment-details ">
				<div v-if="hasPaymentDetails" class="pt-4 pb-4">
					<p v-if="paymentDetails.type">
						<b>{{ $t('paymentType') }}:</b>
						{{ getTypeName(paymentDetails.type) }}
					</p>
					<p v-if="paymentDetails.fullname"><b>{{ paymentDetails.type === 'payoneer' ? $t('recipientName') : $t('holderFullName') }}:</b> {{ paymentDetails.fullname }}</p>
					<p v-if="paymentDetails.iban"><b>{{ $t('iban') }}:</b> {{ paymentDetails.iban }}</p>
					<p v-if="paymentDetails.account_email"><b>{{ paymentDetails.type === 'mellow' ? $t('mellowAccEmail') : $t('payoneerAccEmail') }}:</b> {{ paymentDetails.account_email }}</p>

					<div v-if="paymentDetails.crypto_wallet_address" class="mt-3">
						<p v-if="paymentDetails.crypto_wallet_address.crypto_type"><b>{{ $t('USDT') }}:</b> {{ paymentDetails.crypto_wallet_address.crypto_type }}</p>
						<p v-if="paymentDetails.crypto_wallet_address.wallet_address"><b>{{ $t('cryptoField') }}:</b> {{ paymentDetails.crypto_wallet_address.wallet_address }}</p>
					</div>

					<div v-if="paymentDetails.recipient_address" class="mt-3">

						<p v-if="paymentDetails.type === 'bank_account_non_eu'" class="pt-4 pb-4 "><strong>{{ $t('recipientAddress') }}:</strong></p>

						<p v-if="paymentDetails.recipient_address.country"><b>{{ paymentDetails.type ==='payoneer' ? $t('recipientCountry') : $t('country') }}:</b> {{ paymentDetails.recipient_address.country }}</p>
						<p v-if="paymentDetails.recipient_address.city"><b>{{ $t('city') }}:</b> {{ paymentDetails.recipient_address.city }}</p>
						<p v-if="paymentDetails.recipient_address.street"><b>{{ $t('street') }}:</b> {{ paymentDetails.recipient_address.street }}</p>
						<p v-if="paymentDetails.recipient_address.house_number"><b>{{ $t('houseNumber') }}:</b> {{ paymentDetails.recipient_address.house_number }}</p>
						<p v-if="paymentDetails.recipient_address.apartment_number"><b>{{ $t('apartmentNumber') }}:</b> {{ paymentDetails.recipient_address.apartment_number }}</p>
						<p v-if="paymentDetails.recipient_address.postal_code"><b>{{ $t('postalCode') }}:</b> {{ paymentDetails.recipient_address.postal_code }}</p>
					</div>
				</div>

				<div v-else class="pt-4 pb-4">
					<vs-alert color="danger">
						<div>
							{{  $t('pleaseFillPaymentDetails') }}
						</div>
					</vs-alert>
				</div>
			</div>


			<div class="flex justify-end gap-4">
				<vs-button
					@click="createTask"
					:disabled="!hasPaymentDetails"
					color="success"
				>
					{{ $t('save') }}
				</vs-button>
				<vs-button @click="activePrompt = false" color="warning" type="border">
					{{ $t('cancel') }}
				</vs-button>
			</div>

		</vs-prompt>
	</div>
</template>

<script>
import notifier from "@/mixins/notifier";
import databaseManager from "@/mixins/databaseManager";
import moment from 'moment'
import vSelect from 'vue-select'
import store from "@/store/store";

export default {
	name: "Finances",
	mixins: [notifier, databaseManager],
	components: {
		'v-select': vSelect,
	},
	data() {
		return {
			paymentDetails: null,
			select1: 20,
      		currentPage: 1,
			pagePath: null,
			user: '',
			users: [],
			incomes: 0,
			idOrder: 0,
			date: "",
			off: "",
			indexTab: 0,
			to: "",
			about: "",
			amount: 0,
			search: "",
			activePrompt: false,
			activePrompt2: false,
			popupActiv: false,
			task: {},
			tabs: [
				'new',
				'in_progress',
			],
			orders: {
				request: [],
				history: [],
				accruals: [],
				penalties: [],
				manualCredits: [],
			},
			subjects: [],
			works: [],
			levels: [],
			tasks: [],
			field: [],

			model: {},

			completedTickets: [],

			selectedFinances: [],

      indexToDisableButton: null,
      rowsToDisable: [],

      excelFile: null,
			isLoading: false
		};
	},

  computed: {
	  isExcelFile() {
		  return this.excelFile ? this.excelFile.file : null
	  },
	  types() {
		  return [
			  {
				  name: this.$t('bankEU'),
				  value: 'bank_account_eu',
			  },
			  {
				  name: this.$t('bankNonEU'),
				  value: 'bank_account_non_eu',
			  },
			  {
				  name: this.$t('mellow'),
				  value: 'mellow',
			  },
			  {
				  name: this.$t('payoneer'),
				  value: 'payoneer',
			  },
			  {
				  name: this.$t('crypto'),
				  value: 'crypto',
			  },
			  {
				  name: this.$t('wise'),
				  value: 'wise',
			  }
		  ];
	  },
	  hasPaymentDetails() {
		  if (!this.paymentDetails) return false;

		  const mainFields = [
			  this.paymentDetails.type,
			  this.paymentDetails.fullname,
			  this.paymentDetails.swift,
			  this.paymentDetails.iban,
			  this.paymentDetails.account_email,
		  ];
		  const crypto = this.paymentDetails.crypto_wallet_address || {};
		  const cryptoFields = [
			  crypto.crypto_type,
			  crypto.wallet_address,

		  ];

		  const address = this.paymentDetails.recipient_address || {};
		  const addressFields = [
			  address.country,
			  address.city,
			  address.street,
			  address.house_number,
			  address.apartment_number,
			  address.postal_code
		  ];

		  return mainFields.some(Boolean) || addressFields.some(Boolean);
	  }

  },

	watch: {
		async off() {
			await this.filter();
		},
		async to() {
			await this.filter();
		},
		async user() {
			await this.filter();
		},
		activePrompt() {
			this.getCompletedTasks()
			this.loadPaymentDetails();
		},
    async indexTab(val) {
      await this.filter()
    },
    select1() {
      this.currentPage = 1
    }
	},
	methods: {
    setPageNumber(data) {
			this.currentPage = data;
    },
    addComa(arr, index) {
      if (arr && arr.length > 1 && arr.length !== index + 1) return ', '
      return ''
    },
		showTitle(tab, title) {
			const item = this.orders[tab][0]
			if (item && item.hasOwnProperty(title)) {
				return true
			}
			return false
		},
		selectAllFinances() {
			this.selectedFinances = this.completedTickets;
		},
		cleanSelectedFinances() {
			this.selectedFinances = null;
		},
		async getCompletedTasks() {
			try {
				const arr = await this.dbGetTickets('completed');
				this.completedTickets = arr.data;
			} catch(e) {
				this.notifyError(e.message);
			}
		},
		getLinkToUser(tr) {
			return `/${tr.user.role}/${tr.user.user_id}`;
		},
		async filter() {

			let options = '&';
			if (this.off) options += 'filter[date_from]=' + moment(this.off).format('YYYY-MM-DD') + '&'
			if (this.to) options += 'filter[date_to]=' + moment(this.to).format('YYYY-MM-DD') + '&'
			if (this.user) options += 'filter[user]=' + this.user + '&'

			this.tabs.forEach(item => {
				item.filterOptions = options;
				this.getTickets(item.key, options);
			});
		},
		async removePayout() {
			try {
				this.rowsToDisable.push(this.model.id)

				await this.$http.post(
					"/accountant/payout/cancel/" + this.model.id,
					{status_message: this.about}
				);

				this.notifySuccess(this.$t('rejectSuccessfully'));

				this.about = "";
				this.popupActiv = false;

				// this.tabs.forEach((item) => {
				// 	this.getTickets(item.key);
				// });
        await this.filter()
			} catch (e) {
				if (e.errors) {
					Object.values(e.errors).forEach(err => {
						this.notifyError(err);
					})
				} else {
					this.notifyError(e.message);
				}
			} finally {
					this.rowsToDisable = this.rowsToDisable.filter(elId => elId !== this.model.id)
			}
		},
        checkDisableRowPairs(id) {
            const el = this.rowsToDisable.find(elId => elId === id)
            return el
        },
		async payout(id, tab) {
            this.rowsToDisable.push(id)
			try {
                await this.$http.post(
                    "/accountant/payout/confirm/" + id
				);
				this.popupActiv = false;

                const index = this.orders[tab.key].findIndex(item => item.id === id)
				this.orders[tab.key].splice(index, 1);

                this.$set(this.orders, tab.key, [...this.orders[tab.key]])
				this.notifySuccess(this.$t('completedSuccessfully'));

			} catch (e) {
				if (e.errors) {
					Object.values(e.errors).forEach(err => {
						this.notifyError(err);
					})
				} else {
					this.notifyError(e.message);
				}
			} finally {
					this.rowsToDisable = this.rowsToDisable.filter(elId => elId !== id)
			}
		},
		showCancelDialog(item) {
			this.activePrompt2 = true;
			this.model = item;
		},
		async createTask(id) {
			try {
				if(!this.amount) return;

				let formData = {
					amount: this.amount,
					order_id: this.selectedFinances.map(el => el.id),
					transfer_system: this.paymentDetails.type,
				};

				await this.$http.post(
					"/" + this.$store.state.auth.role + "/payout/create/",
					formData
				);

				this.notifySuccess(this.$t('addedSuccessfully'));
				this.amount = 0;
				this.popupActiv = false;
				this.tabs.forEach((item) => {
					this.getTickets(item.key);
				});

        await this.updateInfoRealtime()

			} catch (e) {
				if (e.errors) {
					Object.values(e.errors).forEach(err => {
						this.notifyError(err[0]);
					})
				} else {
					this.notifyError(e.message);
				}
			}
		},
		deepFind(obj, path) {
			if (!path) return "";
			let paths = path.split("."),
				current = obj,
				i;

			for (i = 0; i < paths.length; ++i) {
				if (current[paths[i]] === undefined) {
					return undefined;
				} else {
					current = current[paths[i]];
				}
			}
			return current;
		},
		async getTickets(type, options) {
      // console.log(type, ' TYPE');
      // console.log(options, ' options');
			try {
				this.isLoading = true

				let url
				let layout = this.$store.state.layout.layout.toLowerCase();
				if (type === 'accruals') {
					url = options ? `/${layout}/payout/get-history-accruals?${options}` : `/${layout}/payout/get-history-accruals`
				} else if (type === 'penalties') {
          url = options ? `/${layout}/payout/get-penalties?${options}` : `/${layout}/payout/get-penalties`
        } else if (type === 'manualCredits') {
          url = options ? `/${layout}/payout/get-handly-payouts?${options}` : `/${layout}/payout/get-handly-payouts`
        } else {
          const tab = this.tabs[this.indexTab]

          if (options && options.length > 2) {
						url = "/" + layout + "/payout?tab=" + type + options
            await this.getExcelFile(tab.key, options)
          } else {
            url = "/" + layout + "/payout?tab=" + type;
            await this.getExcelFile(tab.key, '')
          }
				}

				if(url && url[url.length - 1] === '&') url = url.substr(0, url.length - 1);

        const res = await this.$http.get(url);
        this.$set(this.orders, type, res.data.data)
			} catch (e) {
				this.notifyError(e.message);
			} finally {
				this.isLoading = false
			}
		},
		async getExcelFile(type, options) {
		  if (this.$store.state.auth.role !== "accountant") return
		  try {
			this.excelFile = (await this.$http.get(`/accountant/payout?excel=1&tab=${type}${options}`)).data
		  } catch (e) {
					this.notifyError(e.message);
		  }
		},
		async downloadExcelFile(type, options) {
			if (this.$store.state.auth.role !== "accountant") return

			try {
				const response = await this.$http.get(`/accountant/payout/download-excel?tab=${type}${options}`, {
					headers: {
						Authorization: "Bearer "+ this.$store.state.auth.token,
					},
					responseType: "blob"
				});

				const url = window.URL.createObjectURL(response.data);
				const a = document.createElement("a");
				a.href = url;

				const now = new Date();
				const pad = (n) => n.toString().padStart(2, '0');
				const filename = `${now.getFullYear()}_${pad(now.getMonth()+1)}_${pad(now.getDate())}_${pad(now.getHours())}_${pad(now.getMinutes())}_${pad(now.getSeconds())}.xlsx`;

				a.download = filename;
				document.body.appendChild(a);
				a.click();
				a.remove();
				window.URL.revokeObjectURL(url);

			} catch (error) {
				console.error("Помилка при завантаженні Excel:", error);
			}
		},

		setActiveTab(data) {
      this.indexTab = data
    },
		formatUsers(list) {
			return list.map(item => ({
				id: item.user_id,
				name: `${item.first_name} ${item.last_name}`
			}))
		},
		async updateInfoRealtime() {
			if(this.pagePath !== this.$route.fullPath) { return; }

			const role = this.$store.state.auth.role

			if (role !== "accountant") {
				let balance = (await this.$http.get('/' + role + '/stats/get-balance')).data.data.amount;
				this.incomes = balance.toFixed(2);
			} else {
				this.users = [
					...this.formatUsers((await this.$http.get(`/${role}/author`)).data.data),
					...this.formatUsers((await this.$http.get(`/${role}/manager`)).data.data),
				];
			}

			this.levels = (
				await this.$http.get("/settings/get-quality-levels")
			).data.data;
			this.works = (await this.$http.get("/settings/get-work-types")).data.data;
			this.subjects = (await this.$http.get("/settings/get-subjects")).data.data;

      const tab = this.tabs[this.indexTab]

      // this.getTickets(tab.key);
			this.tabs.forEach((item) => {
				this.getTickets(item.key);
			});
		},

		async loadPaymentDetails() {
			try {
				const res = await this.$http.get(`/${this.$store.state.auth.role}/profile/payment-details`);
				this.paymentDetails = res.data.data || null;

				if (this.paymentDetails.recipient_address) {
					const addr = this.paymentDetails.recipient_address;
					this.country = addr.country;
					this.city = addr.city;
					this.street = addr.street;
					this.house_number = addr.house_number;
					this.apartment_number = addr.apartment_number;
					this.postal_code = addr.postal_code;
				}
				if (this.paymentDetails.crypto_wallet_address) {
					const crpto = this.paymentDetails.crypto_wallet_address;
					this.crypto_type = crpto.crypto_type;
					this.wallet_address = crpto.wallet_address;

				}
			} catch (e) {
				console.error('Failed to load payment details', e);
				this.paymentDetails = null;
			}
		},
		getTypeName(value) {
			const found = this.types.find(t => t.value === value);
			return found ? found.name : value;
		},
	},

	async created() {
		if (this.$store.state.auth.role === "author") {
			this.field = [
				{
					field: "created",
					title: this.$t('date'),
					align: 'center',

				},
				{
					field: "transaction_uid",
					title: this.$t('idTransaction'),
					align: 'center',
				},
				{
					field: "amount",
					title:`${this.$t('sum')}, Є`,
					align: 'center',
				},
				{
					field: "payment_system",
					title: this.$t('paymentSystem'),
					align: 'center',
				},
				{
					field: "order_id",
					title: this.$t('№'),
					align: 'center',
				},
				{
					field: "status",
					title: this.$t('status'),
					align: 'center',
				},
				{
					field: "milestone_id",
					title: this.$t('milestoneId'),
					align: 'center',
				},
				{
					field: "milestone_position",
					title: this.$t('milestonePosition'),
					align: 'center',
				},
				{
					field: "penalty_reason",
					title: this.$t('penaltyReason'),
					align: 'center',
				},
				{
					field: "operation",
					title: this.$t('operation.title'),
					align: 'center',
				},
			];

			this.tabs = [
				{
					key: "request",
					title: this.$t('paymentRequests'),
				},
				{
					key: "history",
					title: this.$t('paymentsHistory'),
				},
				{
					key: "accruals",
					title: this.$t('accrualHistory'),
				},
				{
					key: "penalties",
					title: this.$t('stats.penalties'),
				},
				{
					key: "manualCredits",
					title: this.$t('stats.manualCredits'),
				},
			];
		}
		if (this.$store.state.auth.role === "manager") {
			this.field = [
				{
					field: "created",
					title: this.$t('date'),
					align: 'center',
					width: '20%'

				},
				{
					field: "transaction_uid",
					title: this.$t('idTransaction'),
					align: 'center',
					width: '20%'
				},
				{
					field: "amount",
					title: `${this.$t('sum')}, Є`,
					align: 'center',
					width: '20%'
				},
				{
					field: "payment_system",
					title: this.$t('paymentSystem'),
					align: 'center',
					width: '20%'
				},
				{
					field: "status",
					title: this.$t('status'),
					align: 'center',
					width: '20%'
				},
			];

			this.tabs = [
				{
					key: "request",
					title: this.$t('paymentRequests'),
				},
				{
					key: "history",
					title: this.$t('paymentsHistory'),
				},
			];
		}
		if (this.$store.state.auth.role === "accountant") {
			this.field = [
				{
					field: "user",
					title: this.$t('user'),
					align: 'center',
					width: '12%'

				},
				{
					field: "created",
					title: this.$t('date'),
					align: 'center',
					width: '12%'

				},
				{
					field: "transaction_uid",
					title: this.$t('idTransaction'),
					align: 'center',
					width: '12%'
				},
				{
					field: "amount",
					title: `${this.$t('sum')}, Є`,
					align: 'center',
					width: '12%'
				},
				{
					field: "payment_system",
					title: this.$t('paymentSystem'),
					align: 'center',
					width: '12%'
				},
				{
					field: "status",
					title: this.$t('status'),
					align: 'center',
					width: '12%'
				},
				{
					field: "actions",
					title: this.$t("actions"),
					align: 'center',
					width: '12%'
				},
			];

			this.tabs = [
				{
					key: "request",
					title: this.$t('paymentRequests'),
				},
				{
					key: "history",
					title: this.$t('paymentsHistory'),
				}, {
					key: "canceled",
					title: this.$t('rejectedPayments'),
				},
			];
		}
	},
	async mounted() {
		this.pagePath = this.$route.fullPath;
		await this.updateInfoRealtime();
		await this.loadPaymentDetails();
	},
};
</script>

<style lang="scss">
@import "../assets/scss/vuexy/variables.scss";
@import "../assets/scss/vuexy/functions.scss";

.vs__dropdown-menu {
  min-width: fit-content;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}

.d-flex {
	display: flex;
}

.d-none {
  display: none;
}

.inputInTable {
	border: 0;
	resize: none;
}

.fade-enter, .fade-leave-to
{
	opacity: 0;
}

th.justify-center div {
	justify-content: center;
}

.con-vs-tabs {
	overflow: visible;
}

.buttons {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	@media screen and (max-width: 375px) {
		button {
			margin: 5px 0;
		}
	}
}

.vs-tabs--content {
	padding: 0;
	margin-top: 10px;
}

.vs-con-table .vs-con-tbody {
	border: 0;
	background-color: transparent;
}
.perPage {
  margin-bottom: 10px;
  width: 70px;
  flex: 0 0 auto;

  .vs__dropdown-toggle {
    border-radius: 100px;
  }
	.vs__selected-options {
		padding-left: 13px;
		.vs__selected {
			padding: 0;
			flex: 0 0 auto;
			padding: 0;
		}
	}

  .vs__clear {
    display: none;
  }

  .v-select__selection {
    width: 100%;
    justify-content: center;
  }
}

.v-select {
  margin-bottom: 30px;

  .v-select-footer {
    position: absolute;
    top: 100%;
  }
}

.con-exemple-prompt {
	.append-text {
		height: 2.7rem;
	}

	.vs-button {
		border-left: 0;
	}

	.vx-input-group-append {
		align-items: flex-end;
	}

	.vs-input {
		width: 100%;

		textarea {
			resize: none;
		}
	}
}
.withdraw{
	.vs-dialog {
		footer {
			display: none !important;
		}
	}
}
.vs-table {
	margin-top: 10px;

	tr {
		border-top: 1px solid #cfcfcf;

		&:last-child {
			border-bottom: 1px solid #cfcfcf;
		}
	}
}

.con-vs-tabs .con-slot-tabs {
	overflow: visible;
}

.task {
	background-color: #3ac47d;
	border-radius: 10px;
	padding: 4px 10px;
	color: white;
}

.counter {
	display: inline-block;
	padding: 5px;
	border-radius: 100%;
	font-weight: 600;
	width: 20px;
	height: 20px;
	font-size: 0.7rem;
	border: 1px solid #cfcfcf;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 1;

	&.warn {
		background-color: #f0ad4e;
		color: white;
		border-color: #f0ad4e;
	}
}

.viewTask {
	.vs-popup--title h3 {
		color: $primary;
	}

	.vs-popup--content {
		padding: 0;
	}

	table {
		width: 100%;

		td {
			padding-bottom: 4px;
		}
	}

	.body {
		padding: 1rem;

		table {
			margin-left: -2px;
		}

		p {
			padding-top: 10px;
			font-size: rem(14px);
		}
	}

	.footer {
		border-top: 1px solid rgba(0, 0, 0, 0.05);
		padding: 0.5rem 1rem;
		display: flex;
		justify-content: flex-end;

		button {
			margin-left: 10px;
		}
	}
}

.filter {
	// border-bottom: 1px solid #e5e5e5;
	padding-bottom: 1rem;
	padding-top: 0.5rem;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-wrap: wrap;

	.date {
		display: flex;
		align-items: center;
	}

	.vx-input-group .vx-input-group-default .vs-input {
		width: 150px;
	}

	.search .vs-icon {
		height: 100%;
		width: 35px;
		background: $primary;
		position: absolute;
		top: 0;
		right: 0;
		color: white !important;
		display: flex;
		align-items: center;
		justify-content: center;
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
		font-size: 22px;
	}

	.search .vs-con-input-label {
		width: 270px;
	}
}

.Finances {
	.buttons {
		justify-content: flex-end;
	}

	.button-task {
		border-radius: 22px;
		padding: 0.25rem 0.7rem !important;
	}

	.transfer-status {
		font-weight: 600;

		&_warn {
			color: #efbb40
		}

		&_success {
			color: #4ba44d
		}

		&_failed {
			color: red
		}
	}
}

.finances-status-dropdown {
	margin-left: 9px !important;
}

.download-btn {

  &.visible {
    display: unset;
  }
  .vs-button {
    .vs-button-text {
      display: flex;
      align-items: center;

      .feather-icon {
        margin-left: 5px;
        width: 15px;
      }
    }
  }
}
</style>
